/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Mk_Term_L10Inputs */

const en_mk_term_l10 = /** @type {(inputs: Mk_Term_L10Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`· Phase 1 checkpoint is waiting for you — \`bystep task approve 1\` to continue.`)
};

const id_mk_term_l10 = /** @type {(inputs: Mk_Term_L10Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`· Checkpoint fase 1 menunggu persetujuanmu — \`bystep task approve 1\` untuk lanjut.`)
};

/**
* | output |
* | --- |
* | "· Phase 1 checkpoint is waiting for you — `bystep task approve 1` to continue." |
*
* @param {Mk_Term_L10Inputs} inputs
* @param {{ locale?: "en" | "id" }} options
* @returns {LocalizedString}
*/
export const mk_term_l10 = /** @type {((inputs?: Mk_Term_L10Inputs, options?: { locale?: "en" | "id" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Mk_Term_L10Inputs, { locale?: "en" | "id" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "id") return id_mk_term_l10(inputs)
	return en_mk_term_l10(inputs)
});